export default [
  {
    key: 'walaPayoutRatio',
    label: 'field.walaPayoutRatio',
    rules: 'required|decimal:2|min_value:0',
    type: 'currency',
    class: 'wala',
    cols: 12,
  },
]
